import { lazy } from 'react';

// all payment pages
const AllPaymentsPage = lazy(() => import('./AllPayments'));
const SuccessPage = lazy(() => import('./Success'));

export default {
  AllPaymentsPage,
  SuccessPage,
};
